<script setup>

import { ref, reactive, watch } from 'vue'
import Dialog from 'primevue/dialog'
import { Form as VeeForm, Field } from "vee-validate"
import * as yup from "yup"
import taskService from '@/services/task.service'
import Button from 'primevue/button'
import Icon from '@/components/Icon/Icon.vue'
import ProgressSpinner from 'primevue/progressspinner'
import { createToast } from 'mosha-vue-toastify'
import moment from 'moment'

const visible = ref(false)
const inProgress = ref(false)
const task = reactive({
    uuid: null,
    name: null,
    date: null,
})
const schema = yup.object().shape({
    uuid: yup.string()
        .typeError("L'uuid doit être remplie")
        .required("L'uuid est obligatoire"),
})

const emit = defineEmits(['deleteTask'])

watch(visible, (newVal) => {
    if(newVal == false) {
        task.value = {
            uuid: null,
            name: null,
            date: null,
        }
    }
})

const open = (taskValue) => {
    visible.value = true

    task.uuid = taskValue.uuid
    task.date = taskValue.date
}

const close = () => {
    visible.value = false
}

defineExpose({ open, close })

const handleDelete = (form) => {
    inProgress.value = true

    if(form.uuid !== undefined) {
        taskService.delete({
            uuid: form.uuid,
        }).then(data => {
            emit('deleteTask', data)

            inProgress.value = false

            close()

            createToast('La tâche a été supprimée',
            {
                type: 'success',
                showIcon: false,
                hideProgressBar: true,
                timeout: 4000,
            })
        }).catch(e => {
            inProgress.value = false

            createToast("Erreur pendant la suppression",
            {
                type: 'danger',
                showIcon: false,
                hideProgressBar: true,
                timeout: 4000,
            })
        })
    }
}

</script>

<template>

<div>
    <Dialog
        v-model:visible="visible"
        modal
        header="Supprimer une tâche"
        :style="{ width: '30rem' }"
    >
        <template #header>
            <div class="w-full px-4 py-2 cursor-move text-2xl border-b border-rose-400">
                <span class="font-bold whitespace-nowrap">Supprimer une tâche</span>
            </div>
        </template>

        <div class="mx-4">
            <div class="m-0 px-8 py-8 relative bg-white">
                <VeeForm @submit="handleDelete" :validation-schema="schema"  class="flex flex-col gap-4">
                    <Field id="uuid" v-model="task.uuid" autocomplete="off" name="uuid" class="w-full form-control form-input" type="hidden" />

                    <div>Êtes-vous sûr de vouloir supprimer la transaction {{ task.name }} du {{ moment(task.date).format('DD/MM/YYYY') }} ?</div>

                    <div class="flex justify-center gap-4">
                        <Button type="button" @click="close()" class="px-4 py-2 mt-8 w-32 rounded flex gap-2 justify-center shadow-md border border-black hover:shadow-none hover:bg-gray-100">
                            <Icon name="cancel" :size="12" class="w-4 h-4" /> Annuler
                        </Button>
                        <Button type="submit" :disabled="inProgress" class="px-4 py-2 mt-8 w-36 rounded flex gap-2 justify-center shadow-md border border-black bg-red-100 hover:shadow-none hover:bg-red-500">
                            <span v-if="!inProgress">
                                <Icon name="delete" :size="12" class="w-4 h-4" /> Supprimer
                            </span>
                            <ProgressSpinner
                                v-else
                                style="width: 20px; height: 20px"
                                strokeWidth="5"
                                fill="transparent"
                                animationDuration="2.5s"
                                aria-label="Custom ProgressSpinner"
                                class="m-auto"
                            />
                        </Button>
                    </div>
                </VeeForm>
            </div>
        </div>
    </Dialog>
</div>

</template>
